export type BrandRestrictedEntity = {
  restrictByBrands?: boolean;
  allowedBrands?: string[];
};

export function isAllowedForBrand(
  entity: BrandRestrictedEntity,
  brandId?: string
): boolean {
  if (entity.restrictByBrands !== true) return true;
  const normalizedBrandId = brandId?.trim();
  if (!normalizedBrandId) return false;
  return (entity.allowedBrands ?? []).includes(normalizedBrandId);
}
